import { Button, ButtonProps } from "@chakra-ui/react";
import { FC } from "react";

const disabledStyles = {
  opacity: 0.8,
};

export const ButtonPrimary: FC<ButtonProps & { htmlType?: string }> = (
  props
) => {
  const { children, ...otherProps } = props;
  return (
    <Button
      background="#00BA0F"
      color="#ffffff"
      borderRadius="20px"
      fontSize="11px"
      height="30px"
      px="20px"
      _hover={{
        background: "#00BA0F",
        opacity: 0.8,
      }}
      _disabled={{
        ...disabledStyles,
        _hover: {
          ...disabledStyles,
        },
      }}
      {...otherProps}
    >
      {children}
    </Button>
  );
};
